import script from "./PropertyPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyPanel.vue?vue&type=script&setup=true&lang=js"

import "./PropertyPanel.vue?vue&type=style&index=0&id=15c3ab83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c3ab83"]])

export default __exports__